import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE, LOCATIONS, NAV_LINKS } from "../data/mock";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#0f3d20] dark:bg-black text-slate-200 border-t-4 border-[#800000]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={SITE.logoUrl} alt="Yoshitaka logo" className="h-14 w-14 object-contain" />
              <div className="flex flex-col leading-tight">
                <span className="text-white font-bold text-base">YOSHITAKA</span>
                <span className="text-emerald-300 text-xs tracking-[0.2em] uppercase">Karate-Do</span>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">{t("footer.description")}</p>
          </div>

          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">
              {t("footer.locations")}
            </h4>
            <ul className="space-y-3 text-sm">
              {LOCATIONS.map((loc) => (
                <li key={loc.id} className="flex items-start gap-2">
                  <MapPin size={16} className="text-[#b85a6f] mt-0.5 flex-shrink-0" />
                  <span className="text-slate-300">{loc.address}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">
              {t("footer.get_in_touch")}
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#b85a6f]" />
                <a href={`tel:${SITE.phone.replace(/[^0-9]/g, "")}`} className="text-slate-300 hover:text-white transition-colors">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#b85a6f]" />
                <a href={`mailto:${SITE.email}`} className="text-slate-300 hover:text-white transition-colors break-all">
                  {SITE.email}
                </a>
              </li>
            </ul>
            <div className="mt-5 flex flex-wrap gap-3">
              {NAV_LINKS.map((l) => (
                <Link key={l.to} to={l.to} className="text-xs uppercase tracking-wider text-slate-300 hover:text-[#b85a6f] transition-colors">
                  {t(`nav.${l.key}`)}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-emerald-900/60 dark:border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Yoshitaka Karate-Do. {t("footer.rights")}</p>
          <p>{t("footer.tagline")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
